import { initSentryClient } from "@dealerzone/libs/sentry/client";

initSentryClient();

export { onRouterTransitionStart } from "@dealerzone/libs/sentry/client";
